import React, { PureComponent } from 'react';
import { Field, reduxForm } from 'redux-form';
import { Link } from 'react-router-dom';
import { Input, Checkbox } from '../../components/Form';
import Alert from '../../components/Form/Alert';
import { createValidator, required, match, email, minLength, maxLength } from '../../components/Form/validators';


class UserForm extends PureComponent {
  render() {
    const { handleSubmit, invalid, error, submitting } = this.props;
    
    return (
      <form onSubmit={handleSubmit}>
        {error && <Alert>{error}</Alert>}
        <fieldset className="form-group">
          <legend>Pieeja</legend>
          <Field component={Input} type="email" name="email" label="E-pasts" />
        </fieldset>

        <fieldset className="form-group">
          <legend>Kontaktinformācija</legend>
          <Field component={Input} name="firstName" label="Vārds" />
          <Field component={Input} name="lastName" label="Uzvārds" />
          <Field component={Input} name="phone" label="Tālrunis" />
        </fieldset>
        <fieldset className="form-group">
          <Field
            component={Checkbox}
            name="agree"
            ommitGroupLabel
            label={<span>Piekrītu <Link to="/tos" target="_blank">noteikumiem</Link></span>}
            group={{fieldClass: "col-sm-9 offset-sm-3"}}
          />
        </fieldset>

        <button 
          className="btn pull-right btn-primary btn-lg"
          disabled={invalid || submitting }
          type="submit"
        >
          Turpināt
        </button>
      </form>
    )
  }
}

const validate = createValidator({
  email: [required, email, maxLength(60)],
  password: [required, minLength(6)],
  password2: [required, match('password')],

  firstName: [required, minLength(3), maxLength(30)],
  lastName: [required, minLength(3), maxLength(30)],
  phone: [required, minLength(8)],
  agree: [required]
})

export default reduxForm({
  form: 'register_user',
  validate,
})(UserForm);



// WEBPACK FOOTER //
// ./src/scenes/Registration/UserForm.js